// React
import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'

// Packages
import '@fmauneko/react-dates/initialize'
import * as Sentry from '@sentry/react'
import { Provider } from 'mobx-react'
import moment from 'moment'
import ReactGA from 'react-ga4'
import { IntlProvider } from 'react-intl'
import { BrowserRouter, useLocation } from 'react-router-dom'
import '@fontsource/roboto'

// Internal
import App from './components/App'
import { ApplicationStore } from './stores'
import * as serviceWorker from './serviceWorker'

// Assets
import '@fmauneko/react-dates/lib/css/_datepicker.css'
import './index.css'
import * as messages from './assets/i18n'

Sentry.init({
  dsn: 'https://b765f66a2c5e48c397a52a2ae95cda30@sentry.heliosconnect.fr/11',
  integrations: [Sentry.browserTracingIntegration()],
  environment: process.env.NODE_ENV,
  release: `${process.env.REACT_APP_VERSION}${process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_GIT_HEAD.substring(0, 7) : ''}`,
  sendDefaultPii: true
})

// Load moment locale
try {
  require(`moment/locale/${navigator.language}`)
  moment.locale(navigator.language)
} catch {
  try {
    require(`moment/locale/${navigator.language.split(/[-_]/)[0]}`)
    moment.locale(navigator.language)
    document.documentElement.lang = navigator.language.split(/[-_]/)[0]
  } catch {
    moment.locale('en')
    document.documentElement.lang = navigator.language.split(/[-_]/)[0]
  }
}

// Load react-intl locale
// addLocaleData(require(`react-intl/locale-data/${navigator.language.split(/[-_]/)[0]}`))

const applicationStore = new ApplicationStore()

const RouteAnalytics = () => {
  const location = useLocation()

  useEffect(() => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname
      })
    }
  }, [location.pathname])

  return null
}

if (process.env.REACT_APP_GA_TRACKING_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID)
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname
  })
}

const ReservationEnLigne = () => {
  return (
    <IntlProvider locale={navigator.language} messages={messages[navigator.language.split(/[-_]/)[0]]}>
      <BrowserRouter>
        <RouteAnalytics />
        <Provider applicationStore={applicationStore}>
          <App />
        </Provider>
      </BrowserRouter>
    </IntlProvider>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<ReservationEnLigne />)

serviceWorker.unregister()
